import Udesk from 'Udesk';
import UdeskLocales from 'UdeskLocales';
import React, { FC, memo, useEffect, useMemo, useState } from 'react';
import { Radio } from 'udesk-ui';
import Page from 'Component/common/udesk-qa-page-layout';
import SubRoutes from 'udesk-react/src/components/sub-routes';
import { getCurrentRouteName } from 'Udesk/system/subApp';
import './style.scss';

const TabMap = {
    TICKET: 1,
    CHAT: 2,
};

interface TempalteProps {
    history?: any;
    routes?: any;
}

const Tempalte: FC<TempalteProps> = memo((props) => {
    const locales = UdeskLocales['current'];

    const [currentTab, setCurrentTab] = useState<number>(TabMap.TICKET);

    const onCurrentTabChange = (v: number) => {
        setCurrentTab(v);

        const tab = tabs.find((t) => t.value === v);

        Udesk.ui.routing.transitionTo({
            history: props.history,
            routeName: tab?.route,
        });
    };

    const tabs = useMemo(
        () => [
            {
                value: TabMap.TICKET,
                label: 'Ticket',
                route: getCurrentRouteName('zendeskTicket'),
                pathName: '/ticket',
            },
            {
                value: TabMap.CHAT,
                label: 'Chat',
                route: getCurrentRouteName('zendeskChat'),
                pathName: '/chat',
            },
        ],
        []
    );

    useEffect(() => {
        if (props.history.location?.pathname?.endsWith('/zendesk')) {
            // 重定向
            Udesk.ui.routing.transitionTo({
                history: props.history,
                routeName: getCurrentRouteName('zendeskTicket'),
            });
        } else {
            // 选中 tab
            const tab = tabs.find((t) => props.history.location?.pathname?.endsWith(t.pathName));
            setCurrentTab(tab?.value || TabMap.TICKET);
        }
    }, [props.history, tabs]);

    return (
        <Page
            pageBodyClassName="system-integration-pages"
            title={locales.menu.admin.systemIntegration.text}
        >
            <Radio.Group
                optionType="button"
                options={tabs}
                value={currentTab}
                onChange={(v) => onCurrentTabChange(v.target.value)}
                style={{ marginBottom: 20 }}
            />

            {props.routes.map((route, i) => (
                <SubRoutes key={i} route={route} />
            ))}
        </Page>
    );
});

export default Tempalte;
